/**
 * @module  Experience/Support-landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const SUPPORT_LANDING_CONSTANTS = {
  FAQ_LIMIT: 3,
  LOCATION_HREF: 'javascript:void(0)',
  LOCATION_BLANK: '_blank',
  LOCATION_SELF: '_self',
  SUPPORT_BILLING_URL: '/support-landing/billing',
  SUPPORT_USAGE_URL: '/support-landing/usage',
  SUPPORT_ACCOUNT_URL: '/support-landing/account',
  SUPPORT_DEVICE_URL: '/support-landing/device',
  SUPPORT_BILLINGLANDING_URL: '/billing-landing',
  SUPPORT_CHANGEMSISDN_URL: '/change-msisdn',
  SUPPORT_IMEICHECK_URL: '/imei-check',
  SUPPORT_ACCESSPUK_URL: '/access-puk',
  SUPPORT_CHANGESIM_URL: '/change-sim',
  SUPPORT_LOSTDEVICE_URL: '/lost-stolen-device',
  EXTERNNAL_PHONETAB_URL: 'https://support.t-mobile.com/community/phones-tablets-devices',
  EXTERNAL_PLANSERVICE_URL: 'https://support.t-mobile.com/community/plans-services',
  EXTERNAL_VERIFYIMEI_URL: 'https://www.t-mobile.com/VERIFYIMEI.ASPX',
  WELCOME_URL: 'https://support.t-mobile.com/welcome',
  ROUTE_BILLING: 'billing',
  ROUTE_BILLING_TITLE: 'Billing',
  ROUTE_USAGE: 'usage',
  ROUTE_USAGE_TITLE: 'Usage',
  ROUTE_ACCOUNT: 'account',
  ROUTE_ACCOUNT_TITLE: 'Account',
  ROUTE_DEVICE: 'device',
  ROUTE_DEVICE_TITLE: 'Device',
  ROUTE_UNAVAILABLE: 'N/A',
  WEB_CHANNEL: 'web',
  ACTIVE: 'ACTIVE',
  LOST_STOLEN: 'ELSTS',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED',
};

export const SUPPORT_BLADE_CONSTANTS = {
  BACK: 'back',
  SUBMIT: 'submit',
  BUTTON_CLASS_PRIMARY: 'btn btn-primary',
  CANCELLED: 'CANCELLED',
  BUTTON_CLASS_SECONDARY: 'btn btn-secondary',
  RESUMECANCELLATION: '/resume-cancellation/select-line',
};
